import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BRAND_LOGO } from "@/lib/assets";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    // If already logged in, redirect to admin
    (async () => {
      try {
        await api.get("/auth/me");
        navigate("/admin", { replace: true });
      } catch (_) {
        /* not logged in — stay on login page */
      }
    })();
  }, [navigate]);

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 p-6">
      <div className="bg-white rounded-3xl p-10 max-w-md w-full text-center shadow-[0_24px_60px_rgba(0,0,0,0.08)] border border-black/5">
        <img src={BRAND_LOGO} alt="אמת או חובות" className="h-14 mx-auto mb-6" />
        <h1 className="text-2xl font-[800] mb-2">פאנל ניהול</h1>
        <p className="text-stone-500 mb-8">התחברו עם חשבון Google כדי לגשת לקמפיינים, לידים ואנליטיקה.</p>
        <Button
          onClick={handleLogin}
          data-testid="google-login-btn"
          className="w-full h-14 rounded-full bg-brand-charcoal hover:bg-brand-stone text-white font-bold gap-2"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path fill="#fff" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#fff" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#fff" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path fill="#fff" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
          התחברות עם Google
        </Button>
        <p className="text-xs text-stone-400 mt-6">הגישה מאובטחת עבור צוות "אמת או חובות" בלבד.</p>
      </div>
    </div>
  );
}
